import { ILibraryDocument, ILibraryDocumentWithPagination } from './libraryDocuments.types'
import http, { handleHttpError, handleHttpResponse } from '@/services/http'
import { HTTPResponse } from '@/services/http/http.types.ts'
import { ILibraryGroup } from '@/pages/Library/libraryGroups.types.ts'

const loadLibraryDocuments = (): Promise<HTTPResponse<ILibraryDocumentWithPagination>> => {
  return http.get(`/nsi/v1/library/documents?limit=${1000}`).then(handleHttpResponse).catch(handleHttpError)
}

const createLibraryDocument = (groupId: ILibraryGroup['id'], file: File): Promise<HTTPResponse<ILibraryDocument>> => {
  const formData = new FormData()
  formData.append('groupId', String(groupId))
  formData.append('document', file)

  return http.post(`/nsi/v1/library/documents`, formData).then(handleHttpResponse).catch(handleHttpError)
}

const updateLibraryDocument = (): Promise<HTTPResponse<ILibraryDocument>> => {
  return http.patch(`/nsi/v1/library/documents`).then(handleHttpResponse).catch(handleHttpError)
}

const deleteLibraryDocument = (id: ILibraryDocument['id']): Promise<HTTPResponse<ILibraryDocument>> => {
  return http.delete(`/nsi/v1/library/documents/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

const rawDocument = (id: ILibraryDocument['id'], filename: string): Promise<HTTPResponse<string>> => {
  return http.get(`/nsi/v1/library/documents/${id}/raw/${filename}`).then(handleHttpResponse).catch(handleHttpError)
}

const getDocument = (id: ILibraryDocument['id']): Promise<HTTPResponse<ILibraryDocument>> => {
  return http.get(`/nsi/v1/library/documents/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

const libraryDocumentsApi = {
  loadLibraryDocuments,
  createLibraryDocument,
  updateLibraryDocument,
  deleteLibraryDocument,
  rawDocument,
  getDocument,
}

export default libraryDocumentsApi
